import { BrandButton } from './BrandButton';
import { MainToolbar } from './MainToolbar';
import { SceneInfoMobile } from './InfoPillMobile';
import { useViewerStore } from '@stores/viewerStore';

interface MobileHUDLayoutProps {
  onToggleCinematic: () => void;
}

export function MobileHUDLayout({ onToggleCinematic }: MobileHUDLayoutProps) {
  const hasScene = useViewerStore((s) => s.sceneConfig !== null);

  return (
    <div className="pointer-events-none absolute inset-0">
      <div className="pointer-events-auto absolute top-6 left-5">
        <BrandButton />
      </div>

      {hasScene && (
        <>
          <div className="pointer-events-auto absolute top-6 right-5">
            <SceneInfoMobile />
          </div>

          <div className="pointer-events-auto absolute bottom-[max(14px,env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2">
            <MainToolbar onToggleCinematic={onToggleCinematic} />
          </div>
        </>
      )}
    </div>
  );
}
